import type { GameConfig, TrackConfig } from '../engine/types'

export const TRACK_CONFIGS: TrackConfig[] = [
  {
    id: 'D',
    name: '工期',
    description: 'Deadline — 越大越好，代表更宽松的交付时间',
    min: -10,
    max: 10,
    initial: 0,
    higherIsBetter: true,
    deliverableThreshold: 0,
  },
  {
    id: 'S',
    name: '范围',
    description: 'Scope — 越小越好，代表更可控的功能范围',
    min: -10,
    max: 10,
    initial: 0,
    higherIsBetter: false,
    deliverableThreshold: 3,
  },
  {
    id: 'L',
    name: 'SLA压力',
    description: 'SLA Pressure — 越小越好，代表更合理的服务等级要求',
    min: -10,
    max: 10,
    initial: 0,
    higherIsBetter: false,
    deliverableThreshold: 3,
  },
  {
    id: 'B',
    name: '预算',
    description: 'Budget — 越大越好，代表更充裕的项目预算',
    min: -10,
    max: 10,
    initial: 0,
    higherIsBetter: true,
    deliverableThreshold: 0,
  },
]

export const DEFAULT_CONFIG: GameConfig = {
  tracks: TRACK_CONFIGS,
  totalClauses: 7, // 6 normal + 1 boss
  deliverableThresholds: { D: 0, S: 3, L: 3, B: 0 },
  maxVisitsPerStakeholder: 3,
}
